module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/thurston_cover.7202771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/thurston_cover.jpg
// module id = DFzM
// module chunks = 1